import styled from 'styled-components';

const LeftNavItem = styled.div<{ isOpen?: boolean }>`
  padding: 6px 8px;
  text-decoration: none;
  background-color: var(--color-bg-primary);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 8px;
  user-select: none;
  transition: background-color 0.15s;

  ${(props) =>
    props.isOpen &&
    `
    background-color: var(--color-bg-tertiary);
    span {
      color: var(--color-text-primary) !important;
    }
    svg {
      color: var(--color-text-primary);
    }
  `}

  &:hover {
    background-color: var(--color-bg-tertiary);
  }

  span {
    color: var(--color-text-secondary) !important;
    &:hover {
      color: var(--color-text-primary) !important;
    }
  }

  svg {
    color: var(--color-text-secondary); /* Icon color */
    &:hover {
      color: var(--color-text-primary);
    }
  }
`;

export default LeftNavItem;
